import script from "./SendSettingView.vue?vue&type=script&lang=ts&setup=true"
export * from "./SendSettingView.vue?vue&type=script&lang=ts&setup=true"

import "./SendSettingView.vue?vue&type=style&index=0&id=b5b78978&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/jobs/MYNAVI_MP_VIEW_G_PROD/workspace/view/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5b78978"]])

export default __exports__